import { Box, IconButton, useTheme } from '@mui/material';
import ListCell from 'components/list/list-cell';
import NewListRow from 'components/new-list-row';
import dayjs from 'dayjs';
import { Inbox } from 'lucide-react';
import React from 'react';
import OpenSlotDialog from 'views/order-feed/features/my-supply-plan/features/ofd-2.0/components/orders/dialogs/open-slot-dialog';
import OpenSlotRowBody from 'views/order-feed/features/my-supply-plan/features/ofd-2.0/components/orders/open-slot-row-body';
import { OpenSlot } from 'views/order-feed/features/my-supply-plan/features/ofd-2.0/types/order-assortment.type';
import { useGoogleTagManager } from 'views/order-feed/features/my-supply-plan/hooks/use-google-tag-manager';
import { OrderType, SupplyPlanType } from 'views/order-feed/features/my-supply-plan/types/google-tag-manager/order-feed-events.type';

const cellAlignment = {
  width: '14%',
  maxWidth: '14%',
};

type Props = {
  openSlot: OpenSlot;
};

const StandardOpenSlotRow: React.FC<Props> = ({ openSlot }) => {
  const theme = useTheme();

  const { createOrderFeedEvent } = useGoogleTagManager();

  return (
    <NewListRow
      colSpan={8}
      body={<OpenSlotRowBody openSlot={openSlot} />}
      bodyOnClick={() => {
        createOrderFeedEvent('dropdown', {
          orderType: OrderType.SKIPPED,
          supplyPlanType: SupplyPlanType.OFD2,
        });
      }}>
      <ListCell sx={cellAlignment}>
        <Box display={'flex'} gap={4} alignItems={'center'}>
          <IconButton
            sx={{ backgroundColor: theme.palette.common.white, cursor: 'unset' }}
            disableRipple
            disableTouchRipple
            size="small">
            <Inbox color={theme.palette.common.black} size={17} />
          </IconButton>
          <Box>Open slot</Box>
        </Box>
      </ListCell>
      <ListCell align={'left'} sx={cellAlignment}>
        {'-'}
      </ListCell>
      <ListCell sx={cellAlignment}>{dayjs(openSlot.dispatchDate).format('DD MMM YYYY')}</ListCell>
      <ListCell sx={cellAlignment}>{dayjs(openSlot.arrivalDate).format('DD MMM YYYY')}</ListCell>
      <ListCell align="right">{'-'}</ListCell>
      <ListCell align="right" colSpan={0}>
        <OpenSlotDialog openSlot={openSlot} />
      </ListCell>
    </NewListRow>
  );
};

export default React.memo(StandardOpenSlotRow);
